import axios from "axios";
import { loginResponse } from "@/services/api-schema";
import { KUrls } from "@/helpers/constants";

export const authService = {
  login,
  logout,
};

const authEndpoint = KUrls.AUTHENTICATION_ENDPOINT || "/authenticate";

async function login(username, password) {
  const response = await axios.post(
    `${KUrls.BASE_REST_URL}${authEndpoint}`,
    { username, password },
    {
      "Content-Type": "application/json",
    }
  );
  const data = await handleResponse(response);
  if (data[loginResponse.token]) {
    localStorage.setItem("user", data[loginResponse.token]);
  }
  if (data[loginResponse.userSchemas]) {
    localStorage.setItem(
      "user_schemas",
      JSON.stringify(data[loginResponse.userSchemas])
    );
  }
  return data;
}

function logout() {
  localStorage.removeItem("user");
  localStorage.removeItem("user_schemas");
}

function handleResponse(response) {
  const data = response && response.data;
  if (!response.status && response.status != 200) {
    if (response.status === 401) {
      // unauthorized
    }
    const error = (data && data.message) || response.statusText;
    console.log(error);
    return Promise.reject(error);
  }

  return data;
}
